import { combineReducers } from 'redux'
import { createWrapper } from 'next-redux-wrapper'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { configureStore, ConfigureStoreOptions } from '@reduxjs/toolkit'

import globalReduce from '@app/model/slice'
import { noticesReducer } from '@widgets/Common/Notices'
import restaurantBooking from '@widgets/Restaurant/Booking/model/slice'
import { RestItemReducer } from '@pages/RestItem'
import { NewsGalleryReducer } from '@pages/NewsGallery'
import { SelectionsGalleryReducer } from '@pages/SelectionsGallery'
import { NewsItemReducer } from '@pages/NewsItem'
import { SelectionItemReducer } from '@pages/SelectionItem'
import { ListingReducer } from '@pages/Listing'
import { OwnerPersonalPageReducer } from '@pages/OwnerPersonalPage'
import { FeedbackReducer } from '@widgets/Common/ModalFeedback/'
import { ReviewsReducer } from '@entities/Restaurant/Reviews'
import { FiltersReducer } from '@features/Restaurant/RestaurantFilters'
import { AppHomeReducer } from '@pages/AppHome'
import { MapReducer } from '@widgets/Restaurant/Map'
import { PlugAdsReducer } from '@widgets/Common/PlugAds'
import { GigAssistReducer } from '@widgets/Common/GigAssist'

const pagesReducers = combineReducers({
  app_home: AppHomeReducer,
  rest_item: RestItemReducer,
  news_gallery: NewsGalleryReducer,
  selections_gallery: SelectionsGalleryReducer,
  news_item: NewsItemReducer,
  selection_item: SelectionItemReducer,
  listing: ListingReducer,
  owner_personal: OwnerPersonalPageReducer,
  // rest_reviews: RestReviewsReducer,
  // all_rests_listing: AllRestsListingReducer,
  // search_rests_listing: SearchRestsListingReducer,
  // owner_landing: OwnerLandingReducer,
})

const featuresReducers = combineReducers({
  restaurant_filters: FiltersReducer,
  map: MapReducer,
  plugAds: PlugAdsReducer,
})

const entitiesReducers = combineReducers({
  restaurant_reviews: ReviewsReducer,
})

const rootReducer = combineReducers({
  global: globalReduce,
  pages: pagesReducers,
  notices: noticesReducer,
  booking: restaurantBooking,
  feedback: FeedbackReducer,
  entities: entitiesReducers,
  features: featuresReducers,
  gigAssist: GigAssistReducer,
})

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof globalStore.dispatch & ((action: any) => any)

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

/**
 * @function createGlobalStore
 * @description Создает глобальное хранилище Redux с настройками
 */
let globalStore: ReturnType<typeof configureStore> = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export const createGlobalStore = (initialStore) => {
  const options: ConfigureStoreOptions = {
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  }

  if (typeof window !== 'undefined') {
    console.dev('createGlobalStore', initialStore)
  }

  if (initialStore) options.preloadedState = initialStore
  globalStore = configureStore(options)

  return globalStore
}

export { globalStore }

export const wrapper = createWrapper(createGlobalStore, {
  // TODO: для чего данный лог?
  // debug: process.env.NEXT_PUBLIC_BUILD_ENV === 'development',
})
